import { BsTeacherManagementPageHeaderTab } from './BsTeacherManagementPageHeaderTab';
export default BsTeacherManagementPageHeaderTab;
